<div class="cmp-container learnspace-theme">
  
  <div class="header-container">
    <div class="header responsive-container">
      <mat-icon fontSet="fa" fontIcon="fa-close" class="large-close-icon" (click)="navigateToProgram()"></mat-icon>
      <div class="program-preview">
        <div class="poster-image" [style.backgroundImage]="learnspace ? 'url(' + (learnspace.postermedia?.path || '/assets/wonda/background2_ld.jpg') + ')' : 'unset'">
        </div>
    
        <div class="content-container">
          <div class="info-container" *ngIf="learnspace">
            <div class="title text-truncate programs-h4">{{ learnspace?.title }}</div>
            <user-list class="collaborators" [learnspace]="learnspace" limit="3"></user-list>
            <div class="bottom-bar programs-body-1">
              <div class="collaborators-count" (click)="showLsParticipants(learnspace, $event)">
                <mat-icon fontSet="fa" fontIcon="fa-user-group"></mat-icon>
                <strong>{{ getParticipantsCount(learnspace) }}</strong> collaborators
              </div>
              <div class="simulations-count">
                <svg xmlns="http://www.w3.org/2000/svg" width="34" height="23" viewBox="0 0 34 23" fill="none">
                  <path d="M28.2261 3.80522C27.9509 3.56735 27.5797 3.46268 27.2213 3.5166L24.447 3.93843C17.0392 5.10878 9.48734 4.81381 2.11791 3.5166C1.37872 3.38973 0.652338 4.00821 0.668338 4.75038V18.249C0.649138 18.988 1.38192 19.6128 2.11471 19.4828L4.88904 19.0609C12.2969 17.8906 19.8487 18.1856 27.2181 19.4828C27.9573 19.6096 28.6837 18.9912 28.6677 18.249V4.75038C28.6677 4.38247 28.5077 4.0431 28.2261 3.80522ZM14.668 6.54237C16.012 6.54237 17.1032 7.62391 17.1032 8.95601C17.1032 10.2881 16.012 11.3696 14.668 11.3696C13.3241 11.3696 12.2329 10.2881 12.2329 8.95601C12.2329 7.62391 13.3241 6.54237 14.668 6.54237ZM19.0359 15.6641C19.0359 16.032 18.7351 16.346 18.3223 16.4126C17.1192 16.6029 15.8872 16.698 14.668 16.698C13.4489 16.698 12.2169 16.6029 11.0169 16.4126C10.6009 16.346 10.3001 16.032 10.3001 15.6641C10.3001 13.7611 12.0825 12.2165 14.2744 12.2165H15.068C17.26 12.2165 19.0423 13.7643 19.0423 15.6641H19.0359Z" fill="#424242"/>
                </svg>
                <strong>{{ learnspace?.courses?.length || 0 }}</strong> simulations
              </div>
              <div class="tags" *ngIf="learnspace.properties?.tags && learnspace.properties.tags.length > 0">
                <mat-icon fontSet="fa" fontIcon="fa-tag"></mat-icon>
                <ng-container *ngFor="let tag of learnspace.properties.tags; index as i">
                  <span class="tag">{{ tag }}</span>
                  <span *ngIf="i < learnspace.properties.tags.length - 1">, </span>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <div class="page-container">
    <mat-tab-group vertical [selectedIndex]="getSelectedIndex()" (selectedIndexChange)="onSelectedIndexChange($event)">
      <mat-tab label="OVERVIEW" color="white" class="learnspace-theme">
        <ng-template matTabContent>
          <program-overview [learnspace]="learnspace"></program-overview>
        </ng-template>
      </mat-tab>
      <mat-tab label="REPORTING" color="white" class="learnspace-theme">
        <ng-template matTabContent>
          <program-reporting [learnspace]="learnspace"></program-reporting>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
